import React from 'react';
import { Box, UploadLargeIcon } from 'edenred-ui';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { ProgressBarFill, ProgressBarTrack } from './UploadInProgressStyles';

export const UploadInProgress = () => {
  const { primaryBackColorLight, fontSemiBold } = useTheme();
  const { t } = useTranslation();

  return (
    <Box>
      <Box
        border={`1px solid ${primaryBackColorLight}`}
        borderRadius={2}
        mt={5}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        bgcolor={'#F3FBFF'}
      >
        <Box
          py={10}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          width={350}
          px={6}
          gap={3}
        >
          <UploadLargeIcon />
          <ProgressBarTrack>
            <ProgressBarFill />
          </ProgressBarTrack>
          <Box fontWeight={fontSemiBold}>
            {t('containers.beneficiaries.import_employees.in_progress.title')}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
